import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import { withRouter } from 'react-router-dom';
import { push } from 'react-router-redux';

// Styles
import styles from './styles';

// Material UI
import { withStyles } from 'material-ui/styles';
import Typography from 'material-ui/Typography';
import Stepper, { Step, StepLabel, StepContent } from 'material-ui/Stepper';
import Button from 'material-ui/Button';
import Paper from 'material-ui/Paper';
import Input from 'material-ui/Input';

// Actions
import { saveData } from './actions';

class Start extends Component {

  componentDidMount() {
    //oar_low: 0,oar_high:10,age_low:0,age_high: 65,pref_age:59,income: 0, education: 0,pref_fans: 0
    this.props.saveData(0,10,0,75,0,0,0,0);
  }

  render(){
    const { classes, theme, location } = this.props;

    return(
      <div className={classes.root}>
        <Typography type="sub-heading" color="inherit" className={classes.text}>
          The Adhoc feature lets you filter all candidates with either one of the 6 filters below. Optionally you can skip this step and head to the priority code and color notification filters.
        </Typography>
        <div>
          <Button onClick={() => {this.props.changeRoute("/console/display/adhoc_filters/question1");}} className={classes.button} raised color="primary">
            1. Distance
          </Button>
        </div>
        <div>
        <Button onClick={() => {this.props.changeRoute("/console/display/adhoc_filters/question2");}} className={classes.button} raised color="primary">
          2. OAR Range
        </Button>
      </div>
      <div>
        <Button onClick={() => {this.props.changeRoute("/console/display/adhoc_filters/question3");}} className={classes.button} raised color="primary">
          3. Profile Age
        </Button>
      </div>
      <div>
        <Button onClick={() => {this.props.changeRoute("/console/display/adhoc_filters/question4");}} className={classes.button} raised color="primary">
          4. Oldest Preferred Age
        </Button>
      </div>
      <div>
        <Button onClick={() => {this.props.changeRoute("/console/display/adhoc_filters/question5");}} className={classes.button} raised color="primary">
          5. Education
        </Button>
      </div>
      <div>
        <Button onClick={() => {this.props.changeRoute("/console/display/adhoc_filters/question6");}} className={classes.button} raised color="primary">
          6. Income Range
        </Button>
      </div>
        <div>
          <Button onClick={() => {this.props.changeRoute("/console/display/adhoc_filters/notifications");}} className={classes.button} color="primary">
            SKIP THIS STEP
          </Button>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
    return {
        customer_number: state.customer.number,
        project_id: state.prefix.project_id,
    };
}

const mapDispatchToProps = (dispatch) => {
  return {
    dispatch,
    saveData: (oar_low,oar_high,age_low,age_high,pref_age,income, education,pref_fans) => dispatch(saveData(oar_low,oar_high,age_low,age_high,pref_age,income, education,pref_fans)),
    changeRoute: (url) => dispatch(push(url)),
  }
}

export default withRouter(withStyles(styles, { withTheme: true })(connect(mapStateToProps, mapDispatchToProps)(Start)));



// WEBPACK FOOTER //
// ./src/scenes/Dashboard/scenes/Home/scenes/Adhoc/scenes/Start/index.js